import jQuery from 'jquery'

export default function(){
	jQuery(function(){
		jQuery('.editable-address-link').on('click', function(event){
			const elm = jQuery(this);
			
			const wrapper = elm.parents().filter('.editable-address-wrapper');
			wrapper.addClass('show-form');
			wrapper.find('.edit-address-field').val('true');
			
			event.preventDefault();
		});
	});
}